export type QuotationButton = 'Cotizar' | 'Emitir' | 'Recotizar';

export enum QUOTATION_BUTTON {
  COTIZAR = 'Cotizar',
  EMITIR = 'Emitir',
  RECOTIZAR = 'Recotizar',
}
